import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TourShareService {
  private readonly clearCookieSubject = new Subject<void>();
  clearCookie$ = this.clearCookieSubject.asObservable();

  notifyClearCookie() {
    this.clearCookieSubject.next();
  }
}
